import React, { useState } from 'react'
import { isDesktop } from 'react-device-detect'
import { Trans, useTranslation } from 'react-i18next'

import { ReactComponent as ArrowIcon } from 'assets/landing-images/arrow-right.svg'
import hackenImage from 'assets/landing-images/hacken.svg'
import proPageImage from 'assets/landing-images/pro-page.jpg'
import swapFormImage from 'assets/landing-images/swap-form.jpg'
import swapGIF from 'assets/landing-images/swap.gif'

import { Main, Button, CoinsPanel, TweetsSlider, Footer } from './components'
import { chainsData, countsCards, architectureCards, partnersData } from './data'
import * as S from './styleds'

export default function Landing() {
  const [tradeMode, setTradeMode] = useState<'pro' | 'swap'>('pro')

  const { t } = useTranslation()

  return (
    <S.Root>
      <S.Container>
        <S.MainSection>
          <Main />
        </S.MainSection>
      </S.Container>

      <S.ChainsSection>
        <S.Container>
          <S.Chains>
            {Object.entries(chainsData).map(
              ([chainName, { icon, icon2x, alt }]: [string, { icon: string; icon2x: string; alt: string }]) => (
                <S.Chain key={chainName} data-chain-name={chainName} src={icon} srcSet={`${icon2x} 2x`} alt={alt} />
              )
            )}
          </S.Chains>
        </S.Container>
      </S.ChainsSection>

      <S.Container>
        <S.CountsCards>
          {countsCards.map(({ count, text }) => (
            <S.CountCard key={count + text}>
              <S.CountCardCount>{count}</S.CountCardCount>
              <S.CountCardText>{text}</S.CountCardText>
            </S.CountCard>
          ))}
        </S.CountsCards>
      </S.Container>

      {/* <S.CallToActionSection>
        <S.Container>
          <CallToActionCards />
        </S.Container>
      </S.CallToActionSection> */}

      <S.Container>
        <S.Architecture>
          <S.Title>
            <Trans i18nKey="Defi innovations created for Internet-Scale">
              Defi innovations created
              <br />
              for Internet-Scale
            </Trans>
          </S.Title>
          <S.Text>{t('Join the natural evolution of DeFi')}</S.Text>
          <S.ArchitectureCards>
            {architectureCards.map(({ title, icon, alt, text }) => (
              <S.ArchitectureCard key={title}>
                <S.ArchitectureIcon src={icon} alt={alt} />
                <S.ArchitectureCardTitle>{title}</S.ArchitectureCardTitle>
                <S.ArchitectureText>{text}</S.ArchitectureText>
              </S.ArchitectureCard>
            ))}
          </S.ArchitectureCards>
        </S.Architecture>

        <S.CoinsSection>
          <S.CoinsInfo>
            <S.CoinsText>{t('The best performance of APY in comparison with other exchanges')}</S.CoinsText>
            <Button routeLinkClassName="coins-section-button-desktop" color="red" icon="bag" routeTo="/earn">
              {t('Start Earning')}
            </Button>
          </S.CoinsInfo>
          <S.CoinsPanelWrapper>
            <CoinsPanel />
          </S.CoinsPanelWrapper>
          <Button routeLinkClassName="coins-section-button-mobile" color="red" icon="bag" routeTo="/earn">
            {t('Start Earning')}
          </Button>
        </S.CoinsSection>

        <S.Trade>
          <S.TradeInfo>
            <S.TradeTitle>{t('Choose your trading style')}</S.TradeTitle>
            <S.TradeButtons>
              <S.TradeButton active={tradeMode === 'swap'} onClick={() => setTradeMode('swap')}>
                {t('Swap')}
              </S.TradeButton>
              <S.TradeButton active={tradeMode === 'pro'} onClick={() => setTradeMode('pro')}>
                {t('WOWswap PRO')}
              </S.TradeButton>
            </S.TradeButtons>
            <S.TradeImage
              visibility="mobile"
              src={tradeMode === 'pro' ? proPageImage : swapFormImage}
              alt={tradeMode === 'pro' ? t('WOWswap PRO') : t('WOWswap Swap form')}
            />
            <S.TradeText>
              {tradeMode === 'pro'
                ? t('More trading data, always on chart')
                : t('With our interface you can swap crypto tokens and assets instantly')}
            </S.TradeText>
            <Button
              color="red"
              icon="swap"
              routeTo={tradeMode === 'pro' ? '/pro' : '/swap'}
              disabled={tradeMode === 'pro' && !isDesktop}
            >
              {tradeMode === 'pro' ? (isDesktop ? t('Trade Now') : t('Desktop Only')) : t('Swap Now')}
            </Button>
          </S.TradeInfo>
          <S.TradeImage
            visibility="desktop"
            src={tradeMode === 'pro' ? proPageImage : swapFormImage}
            alt={tradeMode === 'pro' ? t('WOWswap Pro') : t('WOWswap Swap form')}
          />
        </S.Trade>
      </S.Container>

      <S.LeverageSection>
        <S.Container>
          <S.Leverage>
            <S.LeverageGIF src={swapGIF} alt={t('WOWswap Swap steps')} visibility="desktop" />
            <S.LeverageInfo>
              <S.Title>
                <Trans i18nKey="Leverage trading at WOWswap it's easy as 1,2,3">
                  Leverage trading at WOWswap <br />
                  it&apos;s easy as 1,2,3
                </Trans>
              </S.Title>
              <S.Text>{t('More than 200 tokens for trading with x5 leverage')}</S.Text>
              <S.LeverageGIF src={swapGIF} alt={t('Swap steps')} visibility="mobile" />
              <Button color="red" icon="swap" routeTo="/swap">
                {t('Trade Now')}
              </Button>
            </S.LeverageInfo>
          </S.Leverage>
        </S.Container>
      </S.LeverageSection>

      <S.Container>
        <S.Trusted>
          <S.Title>{t('We are trusted')}</S.Title>
          <TweetsSlider />
        </S.Trusted>
      </S.Container>

      <S.AuditSection>
        <S.Container>
          <S.Audit>
            <S.AuditInfo>
              <S.AuditTitle>{t('Smart contract Audited By Hacken')}</S.AuditTitle>
              <S.AuditLogo src={hackenImage} alt="Hacken" visibility="mobile" />
              <S.AuditLink
                href="https://hacken.io/wp-content/uploads/2021/06/WowSwap_03062021SCAudit_Report_2.pdf"
                target="_blank"
              >
                {t('WOWswap audit')}
                <ArrowIcon />
              </S.AuditLink>
            </S.AuditInfo>
            <S.AuditLogo src={hackenImage} alt="Hacken" visibility="desktop" />
          </S.Audit>
        </S.Container>
      </S.AuditSection>

      <S.Container>
        <S.PartnersSection>
          <S.Title>{t('Partners and investors')}</S.Title>
          <S.Partners>
            {Object.entries(partnersData).map(
              ([partner, { icon, icon2x, alt }]: [string, { icon: string; icon2x: string; alt: string }]) => (
                <S.Partner key={partner} data-partner={partner}>
                  <S.PartnerLogo src={icon} srcSet={`${icon2x} 2x`} alt={alt} />
                </S.Partner>
              )
            )}
          </S.Partners>
        </S.PartnersSection>
      </S.Container>

      <S.FooterSection>
        <S.Container>
          <Footer />
        </S.Container>
      </S.FooterSection>
    </S.Root>
  )
}
